package songwritersnotebook.database

import app.cash.sqldelight.SuspendingTransacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import kotlin.Unit
import songwritersnotebook.database.composeApp.newInstance
import songwritersnotebook.database.composeApp.schema

public interface AppDatabase : SuspendingTransacter {
  public val appDatabaseQueries: AppDatabaseQueries

  public val songQueriesQueries: SongQueriesQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.AsyncValue<Unit>>
      get() = AppDatabase::class.schema

    public operator fun invoke(driver: SqlDriver): AppDatabase =
        AppDatabase::class.newInstance(driver)
  }
}
